import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = { current: String }

  connect() {
    if (!this.currentValue) {
      const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      const options = Array.from(this.selectTarget.options)
      
      let matchingOption = options.find(option => 
        option.value === browserTimezone || option.text.includes(browserTimezone)
      )

      if (!matchingOption) {
        // Fall back to Eastern Time (US & Canada)
        matchingOption = options.find(option => 
          option.text.includes("Eastern Time (US & Canada)")
        )
      }

      if (matchingOption) {
        this.selectTarget.value = matchingOption.value
      }
    }
  }
}
